import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import {dark, light} from "../settings/defaultSettings";

Vue.use(Vuetify);

let lightColors = light;
if(window.lightColors) {
    lightColors = window.lightColors;
}

let darkColors = dark;
if(window.darkColors) {
    darkColors = window.darkColors;
}

const vuetify = new Vuetify({
    breakpoint: {
        thresholds: {
            xs: 576,
            sm: 768,
            md: 992,
            lg: 1200,
        }
    },
    icons: {
        iconfont: "mdi",
    },
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            dark: darkColors,
            light: lightColors
        },
        dark: false
    },
    rtl: false
});
export { vuetify };
